import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import styles from "./styles.module.scss";

interface HeaderProps {
  title: string;
  onBack?: () => void;
}

export const SimplePageHeader: React.FC<HeaderProps> = ({
  title = "",
  onBack,
}) => {
  const [block, cn] = useModuleBEM(styles, "Header");
  const { t } = useI18nContext();

  return (
    <div className={block}>
      <div className={cn("logo")}>
        <button onClick={onBack} aria-label={t("back")}>
          <Icon iconName={IconNameEnum.backIcon} />
        </button>
      </div>
      <h1 className={cn("title")}>{title}</h1>
    </div>
  );
};
